"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signupUser = exports.requestPassword = exports.logoutUser = exports.loginUser = exports.fetchUser = exports.checkUser = void 0;
var _reactGa = _interopRequireDefault(require("react-ga4"));
var fetchUser = exports.fetchUser = function fetchUser() {
  return function (dispatch) {
    return fetch('/api/profile', {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status === 'success') {
        var user = response.data;
        _reactGa["default"].set({
          userId: user.id
        });
        dispatch({
          type: 'SAVE_USER',
          user: user
        });
      } else {
        console.warn("failed fetching user: ".concat(response.message));
        dispatch({
          type: 'SAVE_USER',
          user: undefined
        });
      }
    })["catch"](function (ex) {
      return console.log('failed fetching user', ex);
    });
  };
};
var checkUser = exports.checkUser = function checkUser() {
  return function (dispatch) {
    return fetch('/api/authentication/login', {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      var status = response.status,
        data = response.data;
      var token = data && data._token;
      if (data && data.user) {
        dispatch({
          type: 'SAVE_USER',
          user: response.data.user
        });
      }
      return {
        status: status,
        token: token
      };
    })["catch"](function (error) {
      console.log('failed fetching user', error);
      return {
        status: 'failed',
        message: 'WRONG'
      };
    });
  };
};
var loginUser = exports.loginUser = function loginUser(email, password, token) {
  return function (dispatch) {
    return fetch('/api/authentication/login', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({
        email: email,
        password: password,
        _token: token
      })
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      var status = response.status,
        message = response.message,
        data = response.data;
      var errors = data.errors;
      if (data && data.user) {
        dispatch({
          type: 'SAVE_USER',
          user: data.user
        });
      }
      return {
        status: status,
        message: message,
        errors: errors
      };
    })["catch"](function (error) {
      console.log('failed fetching user', error);
      return {
        status: 'failed',
        message: 'WRONG'
      };
    });
  };
};
var logoutUser = exports.logoutUser = function logoutUser() {
  return function (dispatch) {
    return fetch('/account/logout', {
      credentials: 'same-origin'
    }).then(function () {
      dispatch({
        type: 'SAVE_USER',
        user: undefined
      });
    });
  };
};
var signupUser = exports.signupUser = function signupUser(email, phone, firstName, lastName, sex, optIn, token) {
  return function (dispatch) {
    return fetch('/api/authentication/signup', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({
        email: email,
        phone: phone,
        firstName: firstName,
        lastName: lastName,
        sex: sex,
        optIn: optIn,
        _token: token
      })
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      var status = response.status,
        message = response.message,
        data = response.data;
      var errors = data.errors;
      if (data && data.user) {
        dispatch({
          type: 'SAVE_USER',
          user: data.user
        });
      }
      return {
        status: status,
        message: message,
        errors: errors
      };
    })["catch"](function (error) {
      console.warn('failed fetching user', error);
      return {
        status: 'failed',
        message: 'WRONG'
      };
    });
  };
};
var requestPassword = exports.requestPassword = function requestPassword(email) {
  return function () {
    return fetch('/api/authentication/password-recovery', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({
        login_email: email
      })
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      var status = response.status,
        message = response.message,
        data = response.data;
      var errors = data && data.errors;
      return {
        status: status,
        message: message,
        errors: errors
      };
    })["catch"](function () {
      return {
        status: 'failed',
        message: 'WRONG'
      };
    });
  };
};